import script from "./Welcome.vue?vue&type=script&setup=true&lang=js"
export * from "./Welcome.vue?vue&type=script&setup=true&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=d29c1efe&scoped=true&lang=css"

import exportComponent from "/Users/cageyoshida/sourcecodes/lotw-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d29c1efe"]])

export default __exports__